/**
 * The village units side by side: one plan per unit, as chosen or saved. Opened from the village row's
 * "Compare the units" on Home when more than one unit is modelled (moved here from Home's former tiles,
 * 23 Oct 2026). Nothing here is computed: the figures are the saved plans' own.
 */
import React from 'react';
import { formatCurrency } from '../../utils/index.ts';
import DialogShell from '../../components/ui/DialogShell.tsx';
import type { ChosenRvPlan } from '../../features/retirementVillage/rvChosenPlan.ts';

const RvUnitsDialog = ({ units, onClose }: { units: ChosenRvPlan[]; onClose: () => void }) => (
    <DialogShell titleId="rv-units-title" title="The village units side by side" eyebrow="One plan per unit, as chosen or saved" onClose={onClose} size="xl" testId="rv-units-dialog" flush>
        <div className="overflow-x-auto">
            <table className="min-w-full text-[14px] tabular-nums">
                <thead><tr className="border-b border-slate-200 text-left text-[12px] font-semibold text-slate-500">
                    <th className="px-5 py-3">Unit</th><th className="px-5 py-3">Plan</th><th className="px-5 py-3 text-right">Left to the family</th><th className="px-5 py-3 text-right">Age Pension</th><th className="px-5 py-3 text-right">Left over each year</th><th className="px-5 py-3 text-right">Fees a year</th>
                </tr></thead>
                <tbody>
                    {units.map((u) => {
                        const c = u.inputs?.card;
                        if (!c) return null;
                        return (
                            <tr key={String(u.id)} className="border-b border-slate-100">
                                <td className="px-5 py-3"><strong className="text-slate-900">{c.village.name || 'The village'}</strong><br /><span className="text-slate-500">{formatCurrency(c.village.entryFee)} entry payment</span>{u.chosen ? <span className="ml-2 rounded-full bg-emerald-50 px-2 py-0.5 text-[12px] font-semibold text-emerald-800">Chosen</span> : null}</td>
                                <td className="px-5 py-3 text-slate-700">{c.words.title}</td>
                                <td className="px-5 py-3 text-right font-semibold">{formatCurrency(Math.round(c.plan.legacy))}</td>
                                <td className="px-5 py-3 text-right">{formatCurrency(Math.round(c.plan.pension))}</td>
                                <td className="px-5 py-3 text-right">{c.plan.cashflow < 0 ? `short ${formatCurrency(Math.round(-c.plan.cashflow))}` : formatCurrency(Math.round(c.plan.cashflow))}</td>
                                <td className="px-5 py-3 text-right">{formatCurrency(Math.round(c.village.annualOngoing))}</td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
        <p className="px-5 py-3 text-[13px] text-slate-500">Each unit was tested over its own years; figures are as they were when the plan was chosen or saved.</p>
    </DialogShell>
);

export default RvUnitsDialog;
